import React from "react";
import { Navigate } from "react-router-dom";

import * as CryptoJS from "crypto-js";
import { encryptCode } from "../services/functions";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
  fallbackPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
  fallbackPath = "/dashboard/analitik",
}) => {
  const [role, setRole] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const checkRole = () => {
      try {
        const encryptedRole = localStorage.getItem("IOT_ROLE") || "";
        if (encryptedRole) {
          const bytes = CryptoJS.AES.decrypt(encryptedRole, encryptCode);
          const decryptedRole = bytes.toString(CryptoJS.enc.Utf8);
          setRole(decryptedRole);
        } else {
          setRole("");
        }
      } catch (error) {
        console.error("Decrypt role error:", error);
        setRole("");
      } finally {
        setIsLoading(false);
      }
    };

    checkRole();
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #2c2c2c",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p>Memeriksa akses...</p>
      </div>
    );
  }

  const hasAccess = allowedRoles.some(
    (allowedRole) => role.toLowerCase() === allowedRole.toLowerCase(),
  );

  if (!hasAccess) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
